module.exports = __webpack_public_path__ + "img/thermal-conductivity.116da4f.svg";